

































































































import Vue, { VueConstructor } from 'vue';
import services from '../../services';
import EventBus from '../../event-bus';
import { AxiosResponse, AxiosError } from 'axios';
import lang from '../../common/lang/de';
import { ToastMessage } from '../../plugins/toast/models/message';
import { SettingsInformation, ErrorStatesOptions } from '../../models';
import { TokenHelper } from '../../common/utils/TokenHelper';

const { LoginService, CallCenterService } = services;

export default (Vue as VueConstructor<Vue & {
}>).extend({
  name: 'HeaderSection',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      isNewSupportButtonDisabled: false as boolean,
      settings: {} as SettingsInformation,
      settingsValid: false as boolean,
    };
  },
  computed: {
    currentRouteName(): string {
      return this.$route.name as string;
    },
    
    isCallCenterAdmin(): boolean {
      return this.$store.getters['user/isCallCenterAdmin'];
    },
    isGCS() : boolean {
      const typeSupport = this.$store.getters['user/getSupportSelected'];
      if (typeSupport === null) return false;
      return typeSupport === 'GCS';
    },
  },
  mounted() {
    EventBus.$on('select-customer', (status: boolean) => {
      this.isNewSupportButtonDisabled = status;
    });
    EventBus.$on('load-settings', (object: any) => {
      this.settings = object.settings;
      this.settingsValid = object.formValid;
    });
  },
  methods: {
    logout() {
      TokenHelper.deleteToken();
      localStorage.removeItem('callCenterSelectedCustomerNumber');
      this.$store.dispatch('user/setUser', null);
      LoginService.logout();
      this.$router.push({
        path: '/'
      });
    },
    showZuruckButton(currentRoute: string): boolean {
      if (currentRoute === 'SettingsCallCenterIndex' || currentRoute === 'SelectedGCS') {
        return true;
      }
      return false;
    },
    toNewSupportRequest() {
      const customerNumberSelected = localStorage.getItem('callCenterSelectedCustomerNumber') as string;      
      this.$router.push({
        name: 'NewSupportRequest',
        params: { id: customerNumberSelected }
      });
    },
    toSettings() {
      this.$router.push({
        name: 'SettingsCallCenterIndex',
      });
    },
    toGCS() {
      this.$router.push({
        name: 'SelectedGCS',
      });
    },
    saveSettings() {
      if (this.settingsValid) {
        this.$loader.show();
        CallCenterService.saveSettings(this.settings)
          .then((result: AxiosResponse<boolean>) => {
            this.$loader.hide();
          })
          .catch((err: AxiosError) => {
            if (err.response !== undefined && (err.response.status === 401 || err.response.status === 500)) {
              setTimeout(() => {
                this.$loader.hide();
              }, 500);
              this.showError(ErrorStatesOptions.NotAuthorized);
              this.$router.push('/');
            } else {
              setTimeout(() => {
                this.$loader.hide();
              }, 500);
              this.showError(ErrorStatesOptions.UnexpectedError);
            }
          });
      }
    },
    toBackIndexFromSetting() {
      this.$router.go(-1);
    },
    toBack() {
      this.$router.push({
        name: 'CallCenterIndex'
      });
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  }
});
